import { planFeaturesActionTypes } from './PlanFeatures.actionTypes';

const initialState = {
  loading: false,
  error: null,
  allFeaturesAndModules: {},
  plans: {},
};

export default function planFeaturesReducer(state = initialState, action) {
  switch (action.type) {
    case planFeaturesActionTypes.SET_STATE:
      return {
        ...state,
        ...action.payload,
      };
    case planFeaturesActionTypes.SET_ALL_FEATURES_AND_MODULES:
      return {
        ...state,
        allFeaturesAndModules: action.payload,
      };
    case planFeaturesActionTypes.SET_PLANS:
      return {
        ...state,
        plans: action.payload,
      };
    default:
      return state;
  }
}
